import { Button } from 'ui'
import { usePDFStore } from '../../../stores/pdf.store'
import { useSigningForm } from './Provider'
import { buildSigningFieldPath } from './Fields'
import { isNonBindingField } from 'bff'

export const SigningFormNavigator = () => {
  const form = useSigningForm()
  const currentFocusFieldId = usePDFStore((state) => state.currentFocusFieldId)
  const updateStore = usePDFStore((state) => state.update)

  return (
    <div className='absolute bottom-1/2 top-1/2 z-10'>
      <Button
        className='p-0 text-black bg-lime rounded-none w-20 after:absolute after:top-1/2 after:-mt-[-18px] after:border-t-[18px] after:border-b-[18px] after:right-[1em] after:!border-l-primary after:content-[""]'
        variant='secondary'
        onClick={() => {
          const fields = form.filteredFields.filter(
            (field) =>
              form.getValues(buildSigningFieldPath(field)) == null &&
              isNonBindingField(field)
          )

          const getNextFieldId = () => {
            const fallbackId = fields?.[0]?.id

            if (!currentFocusFieldId) return fallbackId

            const currentIndex = fields.findIndex(
              (field) => field.id === currentFocusFieldId
            )

            return fields[currentIndex + 1]?.id || fallbackId
          }

          const nextFieldId = getNextFieldId()

          const fieldNode = document.getElementById(nextFieldId)

          if (fieldNode) {
            fieldNode.scrollIntoView({
              block: 'center',
            })

            if (fieldNode.focus) {
              fieldNode.focus()
            }
          }

          updateStore('currentFocusFieldId', nextFieldId)
        }}
      >
        Siguiente
      </Button>
    </div>
  )
}
